import { produce } from 'immer';
import { trackButtonChange } from '../../../lib/fpti';

const defaultState = {
  isOpen: false,
  logs: [],
  apiHistory: {
    apiHistoryItems: [],
    fetchingHistory: false,
    hasMounted: false
  },
  testAccounts: null
};

export default function testPanelReducer(state = defaultState, action) {
  switch (action.type) {
    case 'TOGGLE_TEST_PANEL':
      trackButtonChange('Test Panel', action.value);
      return produce(state, (draftState) => {
        draftState.isOpen = action.value;
      });
    case 'UPDATE_LOGS':
      return produce(state, (draftState) => {
        if (state.apiHistory.hasMounted) {
          draftState.apiHistory.fetchingHistory = true;
        }
        draftState.logs = [action.value, ...state.logs];
      });
    case 'UPDATE_API_HISTORY':
      return produce(state, (draftState) => {
        draftState.apiHistory = { ...state.apiHistory, ...action.value };
      });
    case 'UPDATE_TEST_ACCOUNTS':
      return produce(state, (draftState) => {
        draftState.testAccounts = action.value;
      });
    case 'RESET_TEST_PANEL':
      return produce(state, (draftState) => {
        draftState.logs = [];
        draftState.apiHistory = defaultState.apiHistory;
      });
    default:
      return state;
  }
}
